import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";

const RegistrationToggle = (props) => {
  const { checked, onChange } = props;

  return (
    <Checkbox
      checked={checked}
      label={checked ? Constants.REGISTERED : Constants.UNREGISTERED}
      onChange={(event, attributes) => onChange(attributes.checked)}
      toggle
      data-testid="registrationToggle"
    />
  );
};

RegistrationToggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

RegistrationToggle.defaultProps = {
  checked: false,
};

export default RegistrationToggle;
